import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';
import { useContext } from 'react';
import { SchedulerContext } from '../../SchedulerContext';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  monthViewTimeTableLayoutProps: {
    height: '100%',
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: { minWidth: '0px !important' },
  },
}));

export const MonthViewTimeTableLayoutProps = (
  props: MonthView.TimeTableLayoutProps
) => {
  const { classes, cx } = useStyles();
  const schedulerContext = useContext(SchedulerContext);

  return (
    <MonthView.TimeTableLayout
      {...props}
      className={cx(
        classes.monthViewTimeTableLayoutProps,
        schedulerContext.currentViewName === 'Month',
        {}
      )}
    ></MonthView.TimeTableLayout>
  );
};
